"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const constants_1 = require("../constants");
/**
 * https://www.figma.com/file/B7QsnUMTNYJuQRRsAnVr0Q/Snapchat%2B-billing-on-the-web?node-id=479%3A24761&mode=dev
 */
function RadioButtonIcon(props) {
    const { className, "data-testid": dataTestId, fill = "#FFFC00", size = constants_1.Sizes.ExtraLarge, innerFill = "black", } = props;
    return ((0, jsx_runtime_1.jsxs)("svg", { xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 32 32", fill: "none", className: className, "data-testId": dataTestId, children: [(0, jsx_runtime_1.jsx)("path", { d: "M15.9999 30.6667C24.1001 30.6667 30.6666 24.1002 30.6666 16C30.6666 7.89986 24.1001 1.33337 15.9999 1.33337C7.89974 1.33337 1.33325 7.89986 1.33325 16C1.33325 24.1002 7.89974 30.6667 15.9999 30.6667Z", fill: fill }), (0, jsx_runtime_1.jsx)("circle", { cx: "16.0001", cy: "16", r: "5.33333", fill: innerFill })] }));
}
exports.default = RadioButtonIcon;
//# sourceMappingURL=index.js.map